module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-05-09-563.b3b049c4.mp4";